var isNonNullish = function isNonNullish(input) {
  return input != null;
};

var richText = function richText(field) {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};

var imageThumbnail = function imageThumbnail(thumbnail) {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};

var link = function link(field) {
  return isNonNullish(field) && ("id" in field || "url" in field);
};

export { imageThumbnail, link, richText };